<div class="wizard-navigation">
    <button *ngIf="showCancel" class="btn btn-primary next-btn" (click)="onCancel()" [disabled]="impersonatedUser">
        Cancel
    </button>
    <div class="spacer"></div>
    <button *ngIf="showPreview" class="btn btn-primary finish-btn" (click)="onPreview()" [disabled]="impersonatedUser">
        Preview
    </button>
    <button *ngIf="showBack" class="btn btn-primary next-btn" (click)="onBack()" [disabled]="impersonatedUser">
        Previous
    </button>
    <button *ngIf="showNext&&!showNextOnly" class="btn btn-primary next-btn mrg-left" (click)="onNext()" [disabled]="disableNext || impersonatedUser">
        Next/Save
    </button>
    <button *ngIf="showNextOnly" class="btn btn-primary next-btn mrg-left" (click)="onNext()" [disabled]="disableNext || impersonatedUser">
        Next
    </button>
    <button *ngIf="showFinish" class="btn btn-primary finish-btn" (click)="onFinish()" [disabled]="impersonatedUser">
        Finish
    </button>
</div>